<template>
    <PageTable endpoint="service" :moreFilter="moreFilter" :aditionalColumns="headers" hideEdit hideNew>
        <template>
            <h1>Atendimentos</h1>
            <v-divider class="mb-4"></v-divider>
            <v-alert icon="warning" prominent text type="error"> A modificação de atendimento somente é permitida pelo ADMINISTRADOR do sistema. </v-alert>

            <FilterDateClientStore @changeDate="changeDate" @changeClient="changeClient" @changeStore="changeStore" @changeExam="changeExam" disableDateWhenClient canDeleteClient canDeleteExam :hideExam="false" />
        </template>


        <template v-slot:extra-column="item">
            <div class="text-center">
                <v-chip class="ma-0" outlined color="success"> {{ $moment(item.deliveryDate).format("DD/MM/YYYY") }} </v-chip>
            </div>
        </template>
    </PageTable>
</template>

<script>
import PageTable from "@/components/core/PageTable";
import FilterDateClientStore from "@/components/shared/FilterDateClientStore";

export default {
    components: { PageTable, FilterDateClientStore },

    data() {
        return {
            moreFilter: "",
            dates: [],
            selectedStore: null,
            selectedClient: null,
            selectedExam: null,
            headers: [
                { text: this.$t("Data Entrega"), value: "extra-column", align: "right", sortable: false },
                { text: this.$t("Cliente"), value: "client", align: "right", sortable: true },
                { text: this.$t("Unidade"), value: "store", align: "right", sortable: true },
            ],
        };
    },
    methods: {
        changeClient(event) {
            this.selectedClient = event;
            this.changeFilter();
        },
        changeDate(event) {
            this.dates = event;
            this.changeFilter();
        },
        changeStore(event) {
            this.selectedStore = event;
            this.changeFilter();
        },
        changeExam(event) {
            this.selectedExam = event;
            this.changeFilter();
        },
        changeFilter() {
            let query = "";

            if (this.dates && this.dates.length == 2) {
                query += `&from=${this.dates[0]}&to=${this.dates[1]}`;
            } else if (this.dates && this.dates.length == 1) {
                query += `&from=${this.dates[0]}&to=${this.dates[0]}`;
            }

            if (this.selectedClient) {
                query += `&client=${this.selectedClient.id}`;
            }
            if (this.selectedStore) {
                query += `&store=${this.selectedStore.id}`;
            }
            if (this.selectedExam) {
                query += `&exam=${this.selectedExam.id}`;
            }
            this.moreFilter = query;
        },
    }
};
</script>